(() => {
  if (window.cgmIvaHint) return;
  window.cgmIvaHint = true;
  const CART10 = '/cart?iva=10';
  const isCart = location.pathname.replace(/\/$/, '').endsWith('/cart');

  const css = document.createElement('style');
  css.textContent = `
    .cgm-iva-hint{display:inline-flex;align-items:center;align-self:center;white-space:nowrap;margin-inline-end:.35rem;padding:.3rem .65rem;border-radius:999px;background:#2E7D32;color:#fff !important;font-size:.78rem;font-weight:700;line-height:1.1;text-decoration:none !important}
    .cgm-iva-hint:hover{background:#1b5e20}
    .cgm-iva-hint__short{display:none}
    @media (max-width:749px){.cgm-iva-hint{font-size:.7rem;padding:.25rem .5rem;margin-inline-end:.15rem}.cgm-iva-hint__long{display:none}.cgm-iva-hint__short{display:inline}}
    .cgm-iva-buy10{display:block;width:100%;margin:.6rem 0 .2rem;padding:.75rem 1rem;border:2px solid #2E7D32;border-radius:14px;background:#fff;color:#2E7D32;font:inherit;font-weight:700;font-size:.95rem;text-align:center;cursor:pointer}
    .cgm-iva-buy10:hover{background:#2E7D32;color:#fff}
    .cgm-iva-buy10[disabled]{opacity:.6;cursor:wait}
    .cgm-iva-buy10__err{display:block;margin:.2rem 0 0;color:#b42318;font-size:.8rem;font-weight:600}
  `;
  document.head.appendChild(css);

  // 1) Scritta accanto alla borsa del carrello, in alto a destra
  function headerHint() {
    if (isCart) return;
    const trigger = document.querySelector('header-actions [data-testid="cart-drawer-trigger"], header-actions a.action__cart');
    if (!trigger || trigger.previousElementSibling?.classList.contains('cgm-iva-hint')) return;
    const a = document.createElement('a');
    a.className = 'cgm-iva-hint';
    a.href = CART10;
    a.innerHTML = '<span class="cgm-iva-hint__long">Clicca qui per IVA 10%</span><span class="cgm-iva-hint__short">IVA 10%</span>';
    a.setAttribute('aria-label', 'Clicca qui per acquistare con IVA agevolata al 10%');
    trigger.parentNode.insertBefore(a, trigger);
  }

  // 2) Pulsante nella scheda prodotto: aggiunge al carrello e apre la scelta IVA 10%
  function productButton() {
    if (!location.pathname.includes('/products/')) return;
    const scope = document.querySelector('[data-testid="product-information"]') || document;
    const note = scope.querySelector('.cgm-iva-price__note');
    if (!note || note.parentNode.querySelector('.cgm-iva-buy10')) return;
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cgm-iva-buy10';
    btn.textContent = 'Acquista con IVA 10% – clicca qui';
    const err = document.createElement('span');
    err.className = 'cgm-iva-buy10__err';
    err.hidden = true;
    btn.addEventListener('click', async () => {
      const form = document.querySelector('[data-testid="product-information"] form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
      const id = form?.querySelector('[name="id"]')?.value;
      const qty = Math.max(1, parseInt(form?.querySelector('[name="quantity"]')?.value || document.querySelector('[name="quantity"]')?.value || '1', 10) || 1);
      if (!id) { location.href = CART10; return; }
      btn.disabled = true; err.hidden = true;
      try {
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
        });
        if (!r.ok) throw new Error('add');
        location.href = CART10;
      } catch (_) {
        btn.disabled = false;
        err.textContent = 'Non è stato possibile aggiungere il prodotto al carrello. Riprova.';
        err.hidden = false;
      }
    });
    note.parentNode.insertBefore(btn, note);
    note.parentNode.insertBefore(err, note);
  }

  // 3) Pagina carrello aperta con ?iva=10: apre subito la scelta IVA 10%
  function cartPreselect() {
    if (!isCart || new URLSearchParams(location.search).get('iva') !== '10') return;
    let tries = 0;
    const timer = setInterval(async () => {
      const el = document.querySelector('.cgm-iva-root');
      if (el && window.cgmIva && !el.dataset.cgmHintDone) {
        el.dataset.cgmHintDone = '1';
        el.dataset.want10 = '1';
        await window.cgmIva.refresh();
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        clearInterval(timer);
      } else if (++tries > 40) clearInterval(timer);
    }, 250);
  }

  function run() { headerHint(); productButton(); }
  const start = () => { run(); cartPreselect(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  let pending = false;
  new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; run(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
